var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_2251)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_2251)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7273 55.6022H29.0909V40.1477L20 33.3295V52.875C20 54.3818 21.2205 55.6024 22.7273 55.6024V55.6022Z",
    fill: "#C0C0D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9092 55.6022H57.2729C58.7796 55.6022 60.0001 54.3817 60.0001 52.8749V33.3295L50.9092 40.1477V55.6022Z",
    fill: "#A6A6C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9092 28.3294V40.1476L60.0001 33.3294V29.6931C60.0001 26.3226 56.1525 24.3976 53.4546 26.4204L50.9092 28.3294Z",
    fill: "#8D8DB9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0908 40.1477V28.3295L39.9999 36.5113L50.9089 28.3295V40.1477L39.9999 48.3295L29.0908 40.1477Z",
    fill: "#F2F2F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.6931V33.3295L29.0909 40.1477V28.3294L26.5455 26.4204C23.8477 24.3977 20 26.3227 20 29.693V29.6931Z",
    fill: "#D9D9E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_2251",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_2251",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg14);
export default __webpack_public_path__ + "static/media/productivityimg14.40f409f2dfa6773da6a282d8572a9c49.svg";
export { ForwardRef as ReactComponent };